
// Assigned to the global object (not a top-level `const`) so it doesn't occupy
// the shared global lexical scope. This avoids an "Identifier 'PUB_SUB_EVENTS'
// has already been declared" SyntaxError when apps (e.g. Boosts) inject their
// own global `const PUB_SUB_EVENTS`. The guard keeps it idempotent.
window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
